import React from 'react'

export default function CourseSwitcher({ courses, courseId, onChange }) {
  if (!courses || courses.length <= 1) return null
  return (
    <div className="course-switcher" role="tablist" aria-label="课程切换">
      {courses.map((course) => {
        const pending = course.pendingHomeworkCount || 0
        const active = String(course.id) === String(courseId)
        return (
          <button
            key={course.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`course-switcher-chip${active ? ' active' : ''}`}
            onClick={() => onChange(null, course.id)}
          >
            {course.name}
            {!!course.resourceCount && (
              <span className="chip-meta">{` · ${course.resourceCount} 关`}</span>
            )}
            {pending > 0 && (
              <span className="chip-meta chip-pending">{` · ${pending} 待办`}</span>
            )}
          </button>
        )
      })}
    </div>
  )
}
